import React from "react";
import { createRoot, Root } from "react-dom/client";
import { Config } from "@customTypes/config";

interface ILocatorWidget {
  config: any;
  init: () => void;
}

const App = React.lazy(() => import("./App"));
const AutocompleteApp = React.lazy(() => import("./AutocompleteApp"));

class LocatorWidget implements ILocatorWidget {
  public config: Config;
  private root?: Root | null;

  constructor(config: any) {
    this.config = config;
  }

  init() {
    if (!this.config) {
      throw new Error("Locator config is not defined");
    }

    window.locatorTenancy = { ...this.config };

    const container = document.querySelector(this.config.selector);
    this.root = container ? createRoot(container) : null;

    if (!this.root) {
      throw new Error(
        `Unable to render Locator widget inside the element with the selector ${this.config.selector}. There is no such element in the HTML document`
      );
    }

    const widget = this.config.widget ?? "full";
    const AppComponent = widget === "autocomplete" ? AutocompleteApp : App;

    this.root.render(<AppComponent config={this.config} />);
  }
}

export { LocatorWidget };
